var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2924_21782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 5.4299H7C6.46957 5.4299 5.96086 5.64061 5.58579 6.01569C5.21071 6.39076 5 6.89947 5 7.4299V19.4299C5 19.9603 5.21071 20.469 5.58579 20.8441C5.96086 21.2192 6.46957 21.4299 7 21.4299H17C17.5304 21.4299 18.0391 21.2192 18.4142 20.8441C18.7893 20.469 19 19.9603 19 19.4299V7.4299C19 6.89947 18.7893 6.39076 18.4142 6.01569C18.0391 5.64061 17.5304 5.4299 17 5.4299H15",
    stroke: "#1890FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5.4299C9 4.89947 9.21071 4.39076 9.58579 4.01569C9.96086 3.64061 10.4696 3.4299 11 3.4299H13C13.5304 3.4299 14.0391 3.64061 14.4142 4.01569C14.7893 4.39076 15 4.89947 15 5.4299C15 5.96033 14.7893 6.46904 14.4142 6.84411C14.0391 7.21919 13.5304 7.4299 13 7.4299H11C10.4696 7.4299 9.96086 7.21919 9.58579 6.84411C9.21071 6.46904 9 5.96033 9 5.4299Z",
    stroke: "#1890FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12.4299H15",
    stroke: "#1890FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16.4299H15",
    stroke: "#1890FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2924_21782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.429901)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/DocumentIcon.e599b31d52e62a0d1e068538f3e2fa33.svg";
export { ForwardRef as ReactComponent };